
// MIXINS
import EventsMixin from '../mixins/events.mixin'

// used also in https://github.com/LoveToKnow/design-system/blob/master/packages/shared-styles/lib/shared-article.scss?rgh-link-date=2021-09-21T15%3A18%3A15Z#L1
const STATIC_CLASS = 'ui-article-body'

export default {
  name: 'UiCmsArticleBody',
  mixins: [EventsMixin],
  /** @type { import('@lovetoknow/ui-components-types').ArticleBodyProps } */
  props: {
    article: {
      type: Array,
      default: () => [],
    },
    rootElement: {
      type: String,
      default: 'div',
    },
    isClientOnly: {
      type: Function,
      // eslint-disable-next-line no-unused-vars
      default: el => false,
    },
    contentClass: {
      type: String,
      default: 'content',
    },
  },
  methods: {
    renderContent(content, h, index) {
      return this.isClientOnly && this.isClientOnly(content)
        ? h('ClientOnly', this.renderInnerContent({ h, content, index })) // same as <ClientOnly> <slot :content="content" :index="index" /> </ClientOnly>
        : this.renderInnerContent({ h, content, index }) // same as <slot :content="content" :index="index" />
    },
    renderInnerContent({ h, content, index }) {
      return (
        // if there is a provided template in the default slot :)
        (this.$scopedSlots.default &&
          this.$scopedSlots.default({
            content,
            index,
          })) ||
        // if there is not a provided template in the default slot just render the HTML content :)
        h('div', { domProps: { innerHTML: content } })
      )
    },
  },
  render(h) {
    return h(
      this.rootElement,
      {
        class: `${STATIC_CLASS} ${this.contentClass}`,
      },
      this.article && this.article.length
        ? this.article.map((content, index) =>
            this.renderContent(content, h, index)
          )
        : ''
    )
  },
}
